import { useEffect, useState } from 'react';

const useOrientation = () => {
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 560); // Tightened breakpoint for phones

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
      setIsMobile(window.innerWidth <= 560); // Consistent with initial state
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call immediately to ensure correct initial state
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isPortrait, isMobile };
};

export default useOrientation;
